<div class="row">
  <div class="col-12">
    <div class="auction_item_card">
      <div class="row">
        <div class="image col-md-4 col-12" (click)="OnNavigate(AuctionData.id)">
          <img [src]="AuctionData.main_image" onerror="this.src='assets/images/default-img.png'" alt="">
          <ng-container *ngIf="ShowBageIcons">
            <div class="joinBageIcon" *ngIf="!AuctionData?.is_me_winner">
              <svg xmlns="http://www.w3.org/2000/svg" width="28.001" height="33" viewBox="0 0 28.001 33">
                <path id="joined-ic"
                  d="M9724.579-21302a.969.969,0,0,1-.97-.969v-4.187a.969.969,0,0,1,.97-.969h.063v-3.154a.962.962,0,0,1,.771-.947,9.682,9.682,0,0,0-.466-3.389,11,11,0,0,1-.567-3.4v-9.023a2.776,2.776,0,0,1,3.668-2.623,2.766,2.766,0,0,1,3.6-2.061,2.778,2.778,0,0,1,2.714-2.213,2.774,2.774,0,0,1,2.715,2.213,2.771,2.771,0,0,1,3.663,2.623v5.547a4.145,4.145,0,0,1,1.1-.068,2.51,2.51,0,0,1,2.511,2.51,31.3,31.3,0,0,1-.021,3.293,4.841,4.841,0,0,1-1.665,3.24,5.541,5.541,0,0,0-1.858,3.33h.258a.969.969,0,0,1,.969.969v3.154h.064a.968.968,0,0,1,.964.969v4.188a.968.968,0,0,1-.964.969Zm13.332-6.125h2.19v-2.189h-2.19Zm-11.341,0h9.408v-2.189h-9.408Zm-.257-19.914v8.938a9.193,9.193,0,0,0,.466,2.875,10.993,10.993,0,0,1,.567,3.48v.5h11.513a7.435,7.435,0,0,1,2.549-4.8,2.906,2.906,0,0,0,1.012-2.2v-2.865a.58.58,0,0,0-.578-.578h-.52a.579.579,0,0,0-.578.578,3.1,3.1,0,0,1-1.853,2.85,2.2,2.2,0,0,0-1.285,1.07.976.976,0,0,1-.921.658.969.969,0,0,1-.916-1.273,3.985,3.985,0,0,1,2.351-2.229,1.164,1.164,0,0,0,.69-1.07v-7.994a.836.836,0,0,0-.835-.84.836.836,0,0,0-.835.84v6.441a.969.969,0,0,1-.97.969.964.964,0,0,1-.964-.969v-8.508a.841.841,0,0,0-.841-.836.837.837,0,0,0-.835.836v8.508a.969.969,0,0,1-.969.969.968.968,0,0,1-.964-.969v-6.441a.836.836,0,0,0-.836-.84.837.837,0,0,0-.84.84v6.441a.968.968,0,0,1-.964.969.969.969,0,0,1-.97-.969v-4.381a.838.838,0,0,0-.835-.84A.842.842,0,0,0,9726.313-21328.039Zm18.108-2.322v-1.863l-.042.025a.964.964,0,0,1-1.339-.268.964.964,0,0,1,.268-1.338c1.6-1.076,1.563-1.055,1.531-1.027-.011,0-.021.016.017-.006a.982.982,0,0,1,.846-.113,12.387,12.387,0,0,1,1.772,1.146.965.965,0,0,1,.268,1.338.973.973,0,0,1-.809.434,1,1,0,0,1-.578-.191v1.863a.968.968,0,0,1-.964.969A.969.969,0,0,1,9744.422-21330.361Zm-22.97,0v-1.863l-.049.025a.963.963,0,0,1-1.338-.268.964.964,0,0,1,.268-1.338c1.6-1.076,1.563-1.055,1.531-1.027-.011,0-.021.016.016-.006a.984.984,0,0,1,.847-.113,12.458,12.458,0,0,1,1.771,1.146.965.965,0,0,1,.269,1.338.973.973,0,0,1-.809.434,1.007,1.007,0,0,1-.579-.191v1.863a.967.967,0,0,1-.963.969A.964.964,0,0,1,9721.452-21330.361Z"
                  transform="translate(-9719.903 21335)" fill="#26a969" />
              </svg>
            </div>
            <div class="WinBageIcon" *ngIf="AuctionData?.is_me_winner">
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32.996" viewBox="0 0 33 32.996">
                <g id="biiding-winner-ic" transform="translate(-1642.631 14721.934)">
                  <path id="Subtraction_9" data-name="Subtraction 9"
                    d="M-16559.506,14367.945h-15.988a.643.643,0,0,1-.645-.641v-3.483a4.9,4.9,0,0,1,4.9-4.9h1.033v-2.705a9.739,9.739,0,0,1-6.314-5.8h-1.16a6.323,6.323,0,0,1-6.318-6.313v-7.222a.645.645,0,0,1,.645-.645h6.189v-.646a.641.641,0,0,1,.641-.641h18.051a.641.641,0,0,1,.641.641v.646h6.189a.645.645,0,0,1,.645.645v7.222a6.323,6.323,0,0,1-6.318,6.313h-1.16a9.748,9.748,0,0,1-6.314,5.8v2.705h1.033a4.9,4.9,0,0,1,4.9,4.9v3.483A.643.643,0,0,1-16559.506,14367.945Zm-11.734-7.733a3.612,3.612,0,0,0-3.607,3.609v2.838h14.7v-2.838a3.612,3.612,0,0,0-3.607-3.609Zm2.322-3.712h0v2.422h2.836v-2.422a10.027,10.027,0,0,1-1.42.1,10.1,10.1,0,0,1-1.416-.1Zm.875-18.113a1.71,1.71,0,0,0-1.219.5l-1.4,1.4a1.726,1.726,0,0,0,0,2.435l.514.512-3.359,3.359a1.908,1.908,0,0,0-.562,1.36,1.908,1.908,0,0,0,.563,1.361,1.91,1.91,0,0,0,1.361.562,1.905,1.905,0,0,0,1.359-.562l2.719-2.718v2.306a.64.64,0,0,0,.641.637h5.865a.64.64,0,0,0,.641-.637v-2.635a.641.641,0,0,0-.641-.641h-2.2l.623-.624a1.711,1.711,0,0,0,.5-1.22,1.707,1.707,0,0,0-.5-1.216l-3.684-3.683A1.7,1.7,0,0,0-16568.043,14338.387Zm10.168,9.452h0a8.99,8.99,0,0,1-.207,1.289h.766a5.034,5.034,0,0,0,5.029-5.027v-6.576h-5.545v1.29h3.613a.644.644,0,0,1,.641.646v4.641a3.743,3.743,0,0,1-3.738,3.737Zm-24.836-10.313h0v6.576a5.034,5.034,0,0,0,5.029,5.027h.766a9.357,9.357,0,0,1-.209-1.29h-.557a3.743,3.743,0,0,1-3.738-3.737v-4.641a.644.644,0,0,1,.641-.646h3.613v-1.29Zm24.877,2.58h0v6.443h.516a2.452,2.452,0,0,0,2.453-2.447v-4Zm-22.3,0h0v4a2.452,2.452,0,0,0,2.453,2.447h.516v-6.443Zm7.984,8.5a.64.64,0,0,1-.455-.187.642.642,0,0,1,0-.907l3.359-3.359.908.908-3.359,3.358A.635.635,0,0,1-16572.15,14348.6Zm9.943-.338h-4.584v-1.344h4.584v1.343Zm-3.553-2.628a.44.44,0,0,1-.311-.131l-3.687-3.684a.441.441,0,0,1,0-.62l1.4-1.4a.432.432,0,0,1,.313-.129.443.443,0,0,1,.313.129l3.684,3.684a.437.437,0,0,1,0,.62l-1.4,1.4A.44.44,0,0,1-16565.76,14345.635Z"
                    transform="translate(18226.631 -29056.883)" fill="#e9580e" />
                  <path id="XMLID_781_"
                    d="M190,432.642a.642.642,0,0,0,.641.641h7.185a.641.641,0,0,0,0-1.283h-7.185A.642.642,0,0,0,190,432.642Z"
                    transform="translate(1464.896 -15126.066)" fill="#e9580e" />
                </g>
              </svg>
            </div>
          </ng-container>
        </div>
        <div class="text col-md-8 col-12">
          <div>
            <span class="status" *ngIf="AuctionData.type == 'ongoing'"><svg xmlns="http://www.w3.org/2000/svg" width="6"
                height="6" viewBox="0 0 6 6">
                <circle id="circle" cx="3" cy="3" r="3" fill="#79cf82" />
              </svg>
              {{'Main Auction.ongoing' | translate}}</span>
            <div class="title" (click)="OnNavigate(AuctionData.id)"> {{AuctionData?.name}}</div>
          </div>
          <!-- <div class="desc" *ngIf="AuctionData?.description">{{AuctionData?.description}}</div> -->
          <div class="category">
            <p *ngIf="ShowBageIcons||SearchPage" class="room_name">
              <img src="./assets/images/icons/roomName.svg" alt="" srcset="">
              {{AuctionData?.room?.name || AuctionData?.room_name}}
            </p>
          </div>

          <div class="category">
            <p><img src="./assets/images/icons/category.svg" alt="" srcset="">
              {{AuctionData?.category?.name}}
            </p>
          </div>

          <div class="mb-2" *ngIf="authUserIsAdmin && !ShowBageIcons">
            <span [ngSwitch]="AuctionData.is_published">
              <p *ngSwitchCase="1" class="published">
                {{'Main Auction.published' | translate}}
              </p>
              <p *ngSwitchCase="0" class="unpublished">
                {{'items-requests.Unpublished' | translate}}
              </p>
              <p *ngSwitchDefault class="unpublished">
                {{'items-requests.Unpublished' | translate}}
              </p>
            </span>
          </div>
          <ng-container *ngIf="!AuctionData?.is_multi_auction">
            <div class="time"><img src="./assets/images/icons/clock.svg" alt="" srcset="">
              {{AuctionData?.start_date |dateUTC :"hh:mm a"}}
              <ng-container *ngIf="AuctionData?.end_at">
                - {{AuctionData?.end_date |dateUTC :"hh:mm a"}}
              </ng-container>
            </div>
            <div class="time"><img src="./assets/images/icons/calender.svg" alt="" srcset="">
              {{AuctionData?.start_date |dateUTC:'LL'}}
            </div>
          </ng-container>



          <div class="footer row">
            <div class="start_cost col-md-6 col-12">
              <p>{{AuctionData?.last_bidding && AuctionData?.winner?.id == _config.getAuthUserInfo()?.user?.id ?
                ("sort.Highest Bid" | translate) : ("Main Auction.Starting bid"|translate)}}</p>
              <div><span>{{"Main Auction.SR"|translate}}</span>
                <strong>{{AuctionData?.last_bidding && AuctionData?.winner?.id ==
                  _config.getAuthUserInfo()?.user?.id ?
                  (AuctionData?.last_bidding|number):(AuctionData?.minimum_price|number)}}</strong>
              </div>
            </div>
            <div class="timer col-md-6 col-12">
              <ng-container *ngIf="!AuctionData?.is_multi_auction">
                <ng-container [ngSwitch]="AuctionData?.type">
                  <ng-container *ngSwitchCase="'upcoming'">
                    <timer [Mode]="'light'" type="date" [time]="AuctionData?.remaining_time" [startORend]="1">
                    </timer>
                  </ng-container>
                  <ng-container *ngSwitchCase="'ongoing'">
                    <!-- <ng-container *ngIf="authUserIsAdmin; else elseTemplate3">
                                <div class="d-flex justify-content-center align-items-center"
                                    *ngIf="AuctionData?.is_reserve_time_started">
                                    <div class="auction-badge" style="max-height: fit-content;">
                                        <div class="badge-text">
                                            <p class="head">The auction has ended</p>
                                            <p class="name">Reserve price not met</p>
                                        </div>
                                        <app-auction-end-count-down [TotalTime]="120"
                                            [RemainingTime]="AuctionData?.remaining_minutes_for_reserve ||0" [
                                            TimerMode="minute"></app-auction-end-count-down>
                                    </div>

                                </div>

                                <timer [Mode]="'light'" type="date" [time]="changeTime(AuctionData?.end_date)"
                                    *ngIf="!AuctionData?.is_reserve_time_started" [startORend]="2">
                                </timer>
                            </ng-container>
                            <ng-template #elseTemplate3> -->
                    <!-- <div class="d-flex justify-content-center align-items-center"
                                    *ngIf="AuctionData?.is_reserve_time_started&&AuctionData?.is_me_last_bidder">

                                    <app-auction-end-count-down style="width: 75px;height: 75px;" [TotalTime]="120"
                                        [RemainingTime]="AuctionData?.remaining_minutes_for_reserve ||0"
                                        TimerMode="minute"></app-auction-end-count-down>

                                    <div class="auction-badge">
                                        <div class="badge-text">
                                            <p class="head">The auction has ended</p>
                                            <p class="name">Reserve price not met</p>
                                        </div>

                                    </div>

                                </div> -->

                    <!-- <div class="auction-badge"
                                    *ngIf="AuctionData?.is_reserve_time_started&&!AuctionData?.is_me_last_bidder">
                                    <div class="badge-text">
                                        <p class="head">The auction has ended</p>
                                        <p class="name">You're not the winning bidder </p>
                                    </div>
                                </div> -->

                    <timer [Mode]="'light'" type="date" [time]="AuctionData?.remaining_time" *ngIf="AuctionData?.end_at"
                      [startORend]="2">
                    </timer>
                    <!-- </ng-template> -->

                  </ng-container>
                  <ng-container *ngSwitchCase="'completed'">
                    <!-- When Auction Compeleted according to Admin -->
                    <ng-container
                      *ngIf="authUserIsAdmin && AuctionData.hasOwnProperty('is_has_winner'); else elseTemplate3">
                      <div class="auction-badge" *ngIf="AuctionData?.is_has_winner">

                        <div class="badge-img rounded-circle" style="overflow: hidden;">
                          <img *ngIf="AuctionData?.winner?.image" [src]="AuctionData?.winner?.image"
                            (error)='AuctionData?.winner.image = ""'>
                          <span *ngIf="!AuctionData?.winner?.image">
                            {{(AuctionData?.winner?.firstname+' '+AuctionData?.winner?.lastname)|
                            shortName }}</span>
                        </div>
                        <div class="badge-text">
                          <p class="head">{{'items-requests.Auction winner' | translate}}</p>
                          <p class="name">{{(AuctionData?.winner?.firstname + ' '
                            +AuctionData?.winner?.lastname ) | titlecase }} </p>
                        </div>
                      </div>

                      <div class="auction-badge" *ngIf="!AuctionData?.is_has_winner">
                        <div class="badge-text">
                          <p class="head">{{'Auction Item.The auction has ended' | translate}}</p>
                          <p class="name">{{'items-requests.With No Winner' | translate}} </p>
                        </div>
                      </div>
                    </ng-container>

                    <!-- When Auction Compeleted according to user -->
                    <ng-template #elseTemplate3>
                      <ng-container *ngIf="AuctionData.hasOwnProperty('is_me_winner'); else elseTemplate4">
                        <div class="auction-badge" *ngIf="!AuctionData?.is_me_winner">
                          <div class="badge-text">
                            <p class="head">{{'Auction Item.The auction has ended' | translate}}</p>
                            <p class="name">{{"Auction Item.You're not the winning bidder" | translate}} </p>
                          </div>
                        </div>

                        <div class="auction-badge" *ngIf="AuctionData?.is_me_winner">
                          <div class="badge-text">
                            <p class="head">{{'Auction Item.The auction has ended' | translate}}</p>
                            <p class="name">{{"You're the winner" | translate}} </p>
                          </div>
                        </div>
                      </ng-container>

                      <ng-template #elseTemplate4>
                        <div class="auction-badge">
                          <div class="badge-text">
                            <!-- <p class="head">The auction has ended</p> -->
                            <p class="name">{{'Auction Item.The auction has ended' | translate}}</p>
                          </div>
                        </div>
                      </ng-template>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <!-- <div class="auction-badge">
                                <div class="badge-text">
                                    <p class="name">The auction has ended </p>
                                </div>
                            </div> -->
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- <app-auction-end-count-down [timer]="120" [strokeWidth]="2"></app-auction-end-count-down> -->
            </div>
            <ng-content #requestInfo></ng-content>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- <div class="auction-badge" *ngIf="AuctionData?.">
    <div class="badge-img rounded-circle">
        <img *ngIf="false" src="sdfsf" (error)='true'>
        <span *ngIf="true">
            {{"khaled Kamal" | shortName }}</span>
    </div>
    <div class="badge-text">
        <p class="head">Auction winner</p>
        <p class="name">{{"Ahmed Elhadabi" |titlecase}} </p>
    </div>
</div> -->